<template>
    <div>
        <!-- 公告详情 -->
		<div :class="[{'single': notifyList.length == 1}, 'notify-popup']" v-if="isShowNotify">
			<div class="notify-content" :class="[scenicType]">
				<div :class="[{horn1:isNew},'horn-icon']"></div>
				<div class="close-icon" @click="$emit('closeNotify')"></div>
				<div :class="[{header1:isNew},'header']">
					公告
				</div>
				<div class="title">
					{{ currentNotify.title }}
				</div>
				<div class="time">
					{{ currentNotify.published_time.text }}
				</div>
				<div class="desc">
					<!-- <rich-text :nodes="currentNotify.content"></rich-text> -->
                    <span v-html="currentNotify.content"></span>
				</div>
				<div :class="[{btn1:isNew},'btn']">
					<span class="prev" @click="handlePage('prev')">上一条</span>
					<span class="next" @click="handlePage('next')">下一条</span>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
    props: {
        isShowNotify: {
            type: Boolean,
            default: false
        },
        notifyList: {
            type: Array
        },
        notifyIx: {
            type: Number
        },
        currentNotify: {
            type: Object
		},
		scenicType: {
			type: String
		},
		isNew: {
            type: [Boolean, Number, String],
            default: false
        }
    },
    data () {
        return {
            
        }
    },
    methods: {
        moveHandle() {
            return
        },
        // 关闭公告
        closeNotify() {
            // this.isShowNotify = false
            this.$emit('closeNotify')
        },
        // 公告上下条查看
        handlePage(type) {
            let ix = type == 'prev' ? this.notifyIx - 1 : this.notifyIx + 1
            if (ix < 0 && type == 'prev') return Toast({ message: '已经是第一条拉' })
            if (ix > this.notifyList.length - 1 && type == 'next') return Toast({ message: '已经是最后一条拉' })
            this.$emit('showOther', ix)
        },
    }
}
</script>

<style lang="scss" scoped>
    .notify-popup {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, .5);
		z-index: 10000;
        text-align: left;
		&.single {
			.notify-content {
				padding-bottom: .4rem;
			}
			.desc {
				max-height: 5.16rem;
			}
			.btn {
				display: none;
			}
		}
		.notify-content {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 6.1rem;
			height: 9.03rem;
			background: #fff;
			border-radius: .3rem;
			padding: 1.15rem .4rem 0;
			box-sizing: border-box;
		}
		.horn-icon {
			position: absolute;
			top: -.8rem;
			left: 50%;
			transform: translateX(-50%);
			width: 1.58rem;
			height: 1.58rem;
			vertical-align: middle;
			border-radius: 50%;
			background: url('../../assets/notify.png') no-repeat;
			background-size: 100% 100%;
			&.horn1{
				background: url('../../assets/notify2.png') no-repeat;
				background-size: 100% 100%;
			}
		}
		.close-icon {
			position: absolute;
			right: 0;
			top: 0;
			width: .6rem;
			height: .6rem;
			background: #E6EDEC;
			border-radius: 0 .3rem 0 .3rem;
			&:before, &:after {
				display: inline-block;
				content: '';
				position: absolute;
				width: .3rem;
				height: .04rem;
				border-radius: .02rem;
				background: #fff;
				top: 50%;
				left: 50%;
			}
			&:before {
				transform: translate(-50%, -50%) rotate(45deg);
			}
			&:after {
				transform: translate(-50%, -50%) rotate(-45deg);
			}
		}
		.header {
			position: relative;
			margin: auto;
			width: 1.30rem;
			text-align: center;
			background: #fff;
			height: .34rem;
			line-height: .34rem;
			font-size: .36rem;
			font-weight: bold;
			color: #009D7A;
			&:before, &:after {
				display: inline-block;
				content: '';
				position: absolute;
				width: .68rem;
				height: .04rem;
				border-radius: .02rem;
				background: #E6EDEC;
				top: 50%;
				transform: translateY(-50%);
			}
			&:before {
				left: -.68rem;
			}
			&:after {
				right: -.68rem;
			}
			&.header1{
				color: #4C493C;
			}
		}
		.title {
			margin: .40rem 0 .30rem;
			font-size: .28rem;
			line-height: .34rem;
			color: #333;
		}
		.time {
			margin-bottom: .30rem;
			font-size: .24rem;
			color: #999;
		}
		.desc {
			max-height: 4.40rem;
			overflow-y: auto;
			font-size: .24rem;
			color: #999;
			line-height: .32rem;
			img {
				border-radius: .20rem;
			}
		}
		.btn {
			// background: #fff;
			position: absolute;
			left: .40rem;
			bottom: 0;
			padding: .40rem 0;
			span {
				display: inline-block;
				width: 2.50rem;
				text-align: center;
				height: .66rem;
				line-height: .66rem;
				box-sizing: border-box;
				border-radius: .10rem;
				font-size: .32rem;
			}
			.prev {
				margin-right: .30rem;
				border: .02rem solid #009D7A;
				color: #009D7A;
			}
			.next {
				background: #009D7A;
				color: #fff;
			}
			&.btn1{
				.prev {
					margin-right: .30rem;
					border: .02rem solid #4C493C;
					color: #4C493C;
				}
				.next {
					background: #4C493C;
					color: #fff;
				}
			}
		}
	}
</style>